export default __webpack_public_path__ + "static/media/programming.40fa3a07.svg";